// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1-Chy","col":"CardReaderDesc_col__IAVnx","label":"CardReaderDesc_label__39R7X"};